import React, { useEffect, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth, logout } from "../../auth/firebase/Firebase";
import { useNavigate } from "react-router-dom";

import { codeSnippet } from "../../assets/const/Images";
import "../../assets/css/Header.css"

const NavHeader = () => {

  const navigate = useNavigate();
  const [user, loading] = useAuthState(auth);
  const [userDetails, setUserDetails] = useState();

  useEffect(() => {
    if (loading) return;
    if (user){
      const stringifiedPerson = localStorage.getItem('user');
      setUserDetails(JSON.parse(stringifiedPerson));
    }
  }, [user, loading, navigate]);

  const userLogout = () => {
    logout();
    setTimeout(() => {
      window.location.reload(false);
    }, 500);
  }

  return (
    <>
      <header className="p-3 mb-3 border-bottom">
        <div className="container">
          <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start">
            <button onClick={() => navigate("/")} className="d-flex align-items-center mb-2 mb-lg-0 text-dark text-decoration-none default-link">
              <img src={codeSnippet.icon} className="codesnippet-icon" alt="code snippet" />
            </button>

            <ul className="nav col-12 col-lg-auto me-lg-auto mb-2 justify-content-center mb-md-0">
              <li><button className="nav-link px-2 link-secondary default-link" onClick={() => navigate("/")}>Home</button></li>
              <li><button className="nav-link px-2 link-secondary default-link" onClick={() => navigate("/snippets")}>Snippets</button></li>
            </ul>

            <form className="col-12 col-lg-auto mb-3 mb-lg-0 me-lg-3">
              <input type="search" className="form-control" placeholder="Search..." aria-label="Search" />
            </form>
            {!loading && !user ? ("") : (
              <div className="dropdown text-end">
                <button className="user-icon-btn  default-link" id="dropdownUser1" data-bs-toggle="dropdown" aria-expanded="false">
                  <div className="user-icon-name">{userDetails !== undefined && userDetails !== null ? userDetails.name : "Profile"}</div>
                </button>
                <ul className="dropdown-menu text-small" aria-labelledby="dropdownUser1">
                  <li><button className="dropdown-item default-link" href="#!">Profile</button></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><button className="dropdown-item default-link" href="#!" onClick={userLogout}>Sign out</button></li>
                </ul>
              </div>
            )}

          </div>
        </div>
      </header>
    </>
  );

}

export default NavHeader;